<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
        <el-button type="primary" plain class="title-btn" @click="back()">返回</el-button>
      </div>
      <div style="width: 500px;" class="detail">
        <el-form ref="infoForm" :model="formDatax" label-width="100px">
          <el-form-item label="活动名称">
            <el-input v-model="formDatax.activityName" :disabled="true" />
          </el-form-item>
          <el-form-item label="活动时间">
            <el-date-picker v-model="formDatax.activityTime" :disabled="true" type="daterange" range-separator="至" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明">
            <el-input v-model="formDatax.activityExplain" :disabled="true" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item label="活动奖励">
            <div v-for="(item,index) in formDatax.activityReward" :key="index" class="d-flex jc-sb">
              <div class="w-35">{{ item.couponName }}</div>
              <div class="w-35">{{ item.count }}张</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">已参与用户</span>
      </div>
      <STable
        ref="detailTableref"
        :url="detailUrl"
        :columns="detailColumns"
        :query="detailQuery"
        :selection="false"
        :toolbar="detailToolbar"
        label-width="100px"
      />
    </el-card>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  props: {
    // 活动信息表单的详情数据
    formData: {
      type: Object,
      default() {
        return {

        }
      }
    },
    // 预留的id，通过id查询详情信息
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      formDatax: {},
      // 详情页的表格数据
      detailUrl: '/activity/pageParticipation',
      detailColumns: [
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'userName'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '注册时间',
          prop: 'createTime'
        }
      ],
      detailQuery: [
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入企业名称'
          // type: 'select3',
          // data: [],
          // remoteMethod: (val) => {
          //   this.loadMechanism(val)
          // }
        }, {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        }, {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        }, {
          label: '注册时间',
          prop: 'timeRange',
          placeholder: '',
          type: 'date2'
        }
      ],
      detailToolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          type: 'primary',
          handle: (index, record) => {
            const url = HOST + '/activity/exportParticipation?activityId=' + this.id
            const data = this.$refs.detailTableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出用户参与记录失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  beforeMount() {
    this.detailUrl = '/activity/pageParticipation?activityId=' + this.id
  },
  mounted() {
    // 接收数据
    this.formDatax = JSON.parse(JSON.stringify(this.formData))
    // 加载优惠券数据
    this.loadCoupon()
  },
  methods: {
    // 加载企业数据
    loadMechanism(val) {
      const data = {
        name: val,
        pageNo: 1,
        pageSize: 100
      }
      this.$store.dispatch('form/handle', {
        url: '/org/page',
        data: data,
        callback: resp => {
          this.detailQuery[0].data = resp.list
        }
      })
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.formDatax.activityReward.forEach(items => {
              resp.list.forEach(item => {
                if (item.couponId === items.couponId) {
                  items.couponName = item.couponName
                }
              })
            })
            this.$forceUpdate()
          }
        }
      })
    },
    back() {
      this.$emit('backHome')
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex{
    display: flex;
  }
  .jc-sb{
    justify-content: space-between;
  }
  .w-35{
    width: 35%;
  }
  .detail{
    /deep/.el-input__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-textarea__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-input{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-separator{
      color: #606266 !important;
    }
    /deep/.el-range__icon{
      color: #606266 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/registrationDetail.vue